type LogoutPushTokenParams = {
  getToken: () => Promise<string | null>;
  unregisterToken: (token: string) => Promise<void>;
};

export async function unregisterPushTokenBeforeLogout({
  getToken,
  unregisterToken,
}: LogoutPushTokenParams) {
  try {
    const token = await getToken();
    if (token) {
      await unregisterToken(token);
    }
  } catch {
    // Logout must still complete when push cleanup is unavailable.
  }
}
